import { Injectable, inject } from '@angular/core';
import { CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';

import { UtmPreservationService } from '../services/utm-preservation.service';

@Injectable({
  providedIn: 'root',
})
export class UtmPreserveGuard implements CanActivateChild {
  private router = inject(Router);
  private utmPreservationService = inject(UtmPreservationService);


  canActivateChild(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (!this.utmPreservationService.isUtmEnabled()) {
      return true;
    }

    const preserved = this.utmPreservationService.preservedUtmParams || {};
    if (Object.keys(preserved).length === 0) {
      return true;
    }

    const tree = this.router.parseUrl(state.url);
    const queryParams = tree.queryParams || {};

    const hasUtmInUrl = Object.keys(queryParams).some(k => k.toLowerCase().startsWith('utm_'));
    if (hasUtmInUrl) {
      return true;
    }

    const normalizedQueryKeys = new Set(Object.keys(queryParams).map(k => k.toLowerCase()));
    const paramsToAdd: Record<string, string> = {};
    
    Object.keys(preserved).forEach(key => {
      if (!normalizedQueryKeys.has(key.toLowerCase())) {
        paramsToAdd[key] = preserved[key];
      }
    });

    if (Object.keys(paramsToAdd).length > 0) {
      tree.queryParams = { ...queryParams, ...paramsToAdd };
      return tree;
    }

    return true;
  }
}


